<ng-container *ngIf="vo$ | async; let vo">
	<app-panel
		headerHeight="3rem"
		isAlwaysOpen="true"
		hasSearchableGrid="true"
		hasRefresh="true"
		maxActionsCount="6"
		[itemsCount]="vo.list.totalItems"
		[actionsAvailable]="toggleActions"
		[actions]="panelActions"
		(search)="search($event)"
		(refresh)="refresh()">
			<div panel-info>
				<ng-container *ngIf="selectionCount">
					<span>{{ selectionCount }} &#32;</span>
					<span
						i18n="@@subscription.list.selectedElements">
						selected-elements</span>
				</ng-container>
			</div>
			<div panel-title class="app-panel__title">
				<mat-icon [svgIcon]="DcIcons.Subscription"></mat-icon>
				<span
					i18n="@@subscription.list.title">
					subscription</span>
			</div>
			<dx-data-grid
				[elementAttr]="{ id: 'subscription-list', class: 'subscription-list' }"
				[dataSource]="dataSource"
				[remoteOperations]="{ paging: true, filtering: true, sorting: true }"
				[filterRow]="{ visible: true, applyFilter: 'auto' }"
				[headerFilter]="{ visible: true }"
				[hoverStateEnabled]="true"
				[showColumnHeaders]="true"
				[allowColumnResizing]="true"
				[wordWrapEnabled]="false"
				[columnAutoWidth]="false"
				[showRowLines]="false"
				[showColumnLines]="false"
				[rowAlternationEnabled]="false"
				[repaintChangesOnly]="true"
				[showBorders]="false"
				[width]="'100%'"
				[noDataText]="''"
				(onCellHoverChanged)="onCellHover($event)"
				(onOptionChanged)="onGridOptionChange($event)"
				(onRowClick)="navigateToDetails($event.data)"
				(onSelectionChanged)="onSelectionChange($event)"
				(onContentReady)="onContentReady()">
					<dxo-selection
						mode="multiple"
						selectAllMode="page"
						showCheckBoxesMode="always"></dxo-selection>

					<dxo-load-panel
						shadingColor="rgba(0,0,0,0)"
						[indicatorSrc]="DcLoaders.LoaderInfinite"
						[height]="100"
						[width]="100"
						[enabled]="true"
						[showIndicator]="true"
						[showPane]="true"
						[shading]="true"></dxo-load-panel>

					<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

					<ng-container *ngFor="let col of vo.list.availableColumns | toArray">
						<dxi-column
							*ngIf="col.field === 'label'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[format]="col.format"
							[visibleIndex]="col.visibleIndex"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[filterOperations]="StringFilterOperations"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[fixed]="false"
							[alignment]="'left'"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							cellTemplate="labelTemplate"></dxi-column>

						<dxi-column
							*ngIf="col.field === 'tags'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[format]="col.format"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[dataType]="col.type"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[filterOperations]="StringFilterOperations"
							[fixed]="false"
							[alignment]="'left'"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							cellTemplate="tagsTemplate">
						</dxi-column>

						<dxi-column
							*ngIf="col.field === 'status'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[format]="col.format"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[dataType]="col.type"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[fixed]="false"
							[alignment]="'left'"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							cellTemplate="statusTemplate">
							<dxo-header-filter
								[dataSource]="statusHeaderFilter">
							</dxo-header-filter>
						</dxi-column>

						<dxi-column
							*ngIf="col.field === 'datablockSource'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterOperations]="StringFilterOperations"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[fixed]="false"
							[alignment]="'left'"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							cellTemplate="datablockSourceTemplate"></dxi-column>

						<dxi-column
							*ngIf="col.field === 'dataCount'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[fixed]="false"
							[alignment]="'left'"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							cellTemplate="dataLinesTemplate"></dxi-column>

						<dxi-column
							*ngIf="col.field === 'updatedBy'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterOperations]="StringFilterOperations"
							[format]="col.format"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[fixed]="false"
							[alignment]="'left'"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							cellTemplate="updatedByTemplate"></dxi-column>
					</ng-container>

					<dxi-column
						[fixed]="false"
						[allowResizing]="false"
						[allowHiding]="false"
						[allowGrouping]="false"
						[allowSearch]="false"
						[allowSorting]="false"
						[alignment]="'left'"
						[visibleIndex]="vo.list.availableColumns.size + 1"
						[width]="70"
						[showInColumnChooser]="false"
						cellTemplate="actionsTemplate"></dxi-column>

				<div class="label-template" *dxTemplate="let cell of 'labelTemplate'">
					<img
						[src]="cell.data['pictogramUrl']"
						[alt]="cell.data['pictogramUrl']" />
					<span appEllipsisTitle
						class="label-template__label"
						id="{{ cmpId }}-{{ cell.data['label'] }}">
							{{ cell.data['label'] }}
						</span>
				</div>

					<div *dxTemplate="let cell of 'dataLinesTemplate'">
									<span>
										{{ cell.data['dataCount'] }}
									</span>
					</div>

					<div *dxTemplate="let cell of 'statusTemplate'">
						<app-status-badge
							[status]="cell.data['status']"></app-status-badge>
					</div>

					<div *dxTemplate="let cell of 'tagsTemplate'">
						<app-tag-configurator
							*ngIf="cell.data['tags'].length !== 0"
							displayMode="tags"
							configMode="View"
							[configuredTags]="cell.data['tags']"></app-tag-configurator>
					</div>

					<div *dxTemplate="let cell of 'updatedByTemplate'">
						<app-avatar
							avatarSize="small"
							withTooltip="true"
							[avatar]="cell.data['updatedBy']"></app-avatar>
					</div>

					<div
						class="datablock-source-column-template"
						matTooltip="open subscription in new tab"
						i18n-matTooltip="@@subscription.list.sourceTooltip"
						matTooltipPosition="after"
						*dxTemplate="let cell of 'datablockSourceTemplate'">
						<a id="{{ cmpId }}-{{ cell.rowIndex }}-datablockSource-nav-link"
							 appNavigate
							 [navigateTo]="cell.data['sourceUrl']"
							 [matTooltip]="cell.data['datablockSource']"
							 [matTooltipDisabled]="cell.data['datablockSource'].length < 24"
							 matTooltipPosition="left">
							{{ cell.data['datablockSource'] }}
						</a>
						<a appNavigate
							 [navigateTo]="cell.data['sourceUrl']"
							 [hidden]="cell.rowIndex !== currentlyHovered">
							<mat-icon [svgIcon]="DcIcons.OpenInNewTab"></mat-icon>
						</a>
					</div>

					<div
						*dxTemplate="let cell of 'actionsTemplate'"
                        [hidden]="cell.rowIndex !== currentlyHovered">
						<div class="actions-column-template">
							<button
								*ngIf="cell.data['status'] !== SubscriptionStatus.Unpublish
													&& cell.data['permissions'].has(ElementPermission.Edit)"
								mat-icon-button
								class="actions-column-template__menu-btn"
								matTooltip="update-data"
								i18n-matTooltip="@@subscription.list.action.updateData"
								matTooltipPosition="left"
								(click)="updateDataForSelected(cell.data, $event)">
								<mat-icon [svgIcon]="ActionIcons.Input"></mat-icon>
							</button>
							<button
									*ngIf="cell.data['status'] === SubscriptionStatus.Unpublish
												&& cell.data['permissions'].has(ElementPermission.Edit)"
									mat-icon-button
									class="actions-column-template__menu-btn"
									matTooltip="initialize"
									i18n-matTooltip="@@subscription.list.action.initialize"
									matTooltipPosition="left"
									(click)="initializeForSelected(cell.data, $event)">
									 <mat-icon [svgIcon]="ActionIcons.Publish"></mat-icon>
							</button>
							<button
								id="{{ cmpId }}-{{ cell.rowIndex }}-actions-menu-btn"
								mat-icon-button
								class="actions-column-template__menu-btn"
								(click)="rowMenuOpen($event, cell.rowIndex)"
								[matMenuTriggerFor]="subscriptionActions"
								[matMenuTriggerData]="{ $implicit: cell.data }">
								<mat-icon [svgIcon]="DcIcons.MenuMoreOptionsHandle"></mat-icon>
							</button>
						</div>
						<mat-menu #subscriptionActions="matMenu">
								<ng-template matMenuContent let-data>
										<!-- view action -->
										<button
											id="{{ cmpId }}-{{ cell.rowIndex }}-view-btn"
											(click)="this.navigateToDetails(data)"
											mat-menu-item>
											<mat-icon [svgIcon]="DcIcons.View"></mat-icon>
											<span
												i18n="@@subscription.list.action.view">
												view-action</span>
										</button>

										<!-- activate action -->
										<button
											*ngIf="cell.data['status'] === SubscriptionStatus.UnAvailable
													&& cell.data['permissions'].has(ElementPermission.Edit)"
											id="{{ cmpId }}-{{ cell.rowIndex }}-activate-btn"
											(click)="activateSelected(data)"
											mat-menu-item>
											<mat-icon [svgIcon]="ActionIcons.Share"></mat-icon>
											<span
												i18n="@@subscription.list.action.activate">
												activate-action</span>
										</button>

										<!-- deactivate action -->
										<button
											*ngIf="cell.data['status'] === SubscriptionStatus.Available
														&& cell.data['permissions'].has(ElementPermission.Edit)"
											id="{{ cmpId }}-{{ cell.rowIndex }}-deactivate-btn"
											(click)="deactivateSelected(data)"
											mat-menu-item>
											<mat-icon [svgIcon]="ActionIcons.ShareOff"></mat-icon>
											<span
												i18n="@@subscription.list.action.deactivate">
												deactivate-action</span>
										</button>

										<!-- clear data action -->
										<button
											*ngIf="cell.data['status'] !== SubscriptionStatus.Unpublish
														&& cell.data['permissions'].has(ElementPermission.Edit)"
											id="{{ cmpId }}-{{ cell.rowIndex }}-delete-data-btn"
											(click)="clearDataSelected(data)"
											mat-menu-item>
											<mat-icon [svgIcon]="ActionIcons.Output"></mat-icon>
											<span
												i18n="@@subscription.list.action.clearData">
												clear-data-action</span>
										</button>

										<!-- delete action -->
										<button
											*ngIf="cell.data['permissions'].has(ElementPermission.Delete)"
											id="{{ cmpId }}-{{ cell.rowIndex }}-delete-btn"
											(click)="deleteSelected(data)"
											mat-menu-item>
											<mat-icon [svgIcon]="ActionIcons.Delete"></mat-icon>
											<span
												i18n="@@subscription.list.action.delete">
												delete-action</span>
										</button>
								</ng-template>
						</mat-menu>

					</div>

					<dxo-group-panel [visible]="true"></dxo-group-panel>

					<!-- Sorting	-->
					<dxo-sorting mode="multiple"></dxo-sorting>

					<!-- Filterable columns	-->
					<dxo-header-filter [visible]="true"></dxo-header-filter>

					<dxo-filter-row
						[visible]="vo.list.availableColumns.size !== 0"></dxo-filter-row>

					<!-- Pagination -->
					<dxo-paging [pageSize]="vo.size" [pageIndex]="vo.page"></dxo-paging>
					<dxo-pager
						[visible]="true"
						[showPageSizeSelector]="true"
						[allowedPageSizes]="allowedPageSizes"
						[showInfo]="true"
						[showNavigationButtons]="true"></dxo-pager>

					<dxo-column-chooser
						[allowSearch]="true"
						[enabled]="false"
						[mode]="'select'">
						<dxo-selection
							[allowSelectAll]="true"
							[recursive]="false"></dxo-selection>
					</dxo-column-chooser>

					<dxo-filter-panel [visible]="true"></dxo-filter-panel>

					<dxo-state-storing
						type="custom"
						[enabled]="true"
						[savingTimeout]="160"
						[customLoad]="loadState"
						[customSave]="saveState"></dxo-state-storing>
			</dx-data-grid>
			<ng-container
				*ngIf="vo.list.elements.size === 0"
				[ngTemplateOutlet]="noData"
				[ngTemplateOutletContext]="{hasCreatePermission : vo.hasCreatePermission}"></ng-container>
	</app-panel>
</ng-container>

<ng-template #noData let-hasCreatePermission="hasCreatePermission">
	<div class="no-data-template">
		<mat-icon
			[svgIcon]="DcIcons.Subscription"></mat-icon>
		<app-button
			*ngIf="hasCreatePermission"
			class="small"
			id="{{ cmpId }}-add-new"
			[leftIcon]="DcIcons.AddElement"
			i18n="@@subscription.action.addNew"
			(click)="navigateToSubscriptionCreate()">
			new-subscription
		</app-button>
	</div>
</ng-template>

